import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import { BsThreeDotsVertical } from 'react-icons/bs';
import StringInput from '@appblocks/frontend/cloudclient/Components/StringInput';
import isEqual from 'lodash/isEqual';

const useDeepCompareEffect = (callback, dependencies) => {
    const currentDependenciesRef = useRef();

    if (!isEqual(currentDependenciesRef.current, dependencies)) {
        currentDependenciesRef.current = dependencies;
    }

    useEffect(callback, [currentDependenciesRef.current]);
};

export default function ExpressionBuilder(props) {
    const {
        property, value, state, onChange, properties, disabled, dataTestId,
    } = props;

    const [changes, setChanges] = useState({});

    useDeepCompareEffect(() => {
        const newRules = value.rules.map(
            (rule, index) => ({ ...rule, ...changes[index] }),
        );
        onChange(property, { ...value, rules: newRules });
        setChanges({});
    }, [changes]);

    const onRuleChange = (ruleIndex, newValue, ruleProperty) => {
        setChanges({
            ...changes,
            [ruleIndex]: { ...changes[ruleIndex], [ruleProperty]: newValue },
        });
    };

    const addRule = () => {
        const newRules = value && value.rules ? [...value.rules] : [];
        newRules.push({ field: '', operator: '==', value: '' });
        onChange(property, { ...value, rules: newRules });
    };

    const clearFilters = () => {
        const newRules = [];
        onChange(property, { ...value, rules: newRules });
    };

    const removeRule = (ruleIndex) => {
        const newRules = [...value.rules];
        newRules.splice(ruleIndex, 1);
        onChange(property, { ...value, rules: newRules });
    };

    const renderRule = useCallback((rule, index) => {
        return (
            <div
                key={index}
                className="form-group mt-2 d-flex"
            >
                <div
                    style={{
                        width: '50%',
                    }}
                    data-testid={`${dataTestId}_${index}-field`}
                >
                    <StringInput
                        className="form-control"
                        completionContext={properties}
                        placeholder="Field"
                        value={rule.field}
                        onChange={(val) => {
                            onRuleChange(index, val, 'field');
                        }}
                        disabled={disabled}
                    />
                </div>
                <div
                    className="g-0 mx-1"
                    style={{
                        width: 40,
                    }}
                    data-testid={`${dataTestId}_${index}-operator`}
                >
                    <select
                        disabled={disabled}
                        value={rule.operator}
                        className="form-control"
                        onChange={e => onRuleChange(index, e.target.value, 'operator')}
                    >
                        <option value="==">=</option>
                        <option value="!=">!=</option>
                        <option value=">">{'>'}</option>
                        <option value="<">{'<'}</option>
                        <option value=">=">{'>='}</option>
                        <option value="<=">{'<='}</option>
                    </select>
                </div>
                <div
                    className="flex-grow-1"
                    data-testid={`${dataTestId}_${index}-value`}
                    style={{
                        width: '50%',
                    }}
                >
                    <StringInput
                        disabled={disabled}
                        className="form-control"
                        completionContext={properties}
                        placeholder="Value"
                        value={rule.value}
                        onChange={(val) => {
                            onRuleChange(index, val, 'value');
                        }}
                    />
                </div>
                <div className="ms-1">
                    <Dropdown>
                        <Dropdown.Toggle disabled={disabled} variant="light" className="dropdown-custom">
                            <BsThreeDotsVertical />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => removeRule(index)}
                            >
                                Remove
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        );
    }, [value, disabled]);

    return (
        <div>
            {/* {value.rules.length > 0 && (
                <div className="row">
                    <div className="col-md-1">
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            onClick={clearFilters}
                        >
                            Clear
                        </button>
                    </div>
                </div>
            )} */}
            {(value && value.rules) && value.rules.map((rule, index) => renderRule(rule, index))}
            <div className="row">
                <div className="col-md-1">
                    <button
                        type="button"
                        className="btn btn-primary btn-sm mt-2"
                        onClick={addRule}
                        disabled={disabled}
                    >
                        Add
                    </button>
                </div>
            </div>
        </div>
    );
}
